<div class="ax-barcode" [ngClass]="isStandalone ? 'ax-barcode--standalone' : ''">
    <input type="text" ax-input [placeholder]="placeholder" [ngModel]="barcode" (ngModelChange)="updateBarcode($event)" (keyup.enter)="onEnter()">
</div>
